import { atom } from "jotai";

// Incremented each time the user taps the More tab.
// SettingsAndToolsPage watches this to reset its IonNav stack to root.
export const settingsNavResetAtom = atom(0);
